import { render, staticRenderFns } from "./NatConIndividualAwardList.vue?vue&type=template&id=a5610a52"
import script from "./NatConIndividualAwardList.vue?vue&type=script&lang=js"
export * from "./NatConIndividualAwardList.vue?vue&type=script&lang=js"
import style0 from "./NatConIndividualAwardList.vue?vue&type=style&index=0&id=a5610a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports